import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const SecurityActions = createActionGroup({
  source: 'Security',
  events: {
    'Sign In Sso': props<{ email: string; token: string }>(),
    'Sign In Success': props<{ token: string }>(),
    'Sign In Failure': emptyProps(),
    'Authenticate Success': props<{ token: string; userId: string }>(),
    'Sign Out': emptyProps(),
    'Sign Out Success': emptyProps(),
    'Sign Out Failure': emptyProps(),
  },
});
